/**
 * Constants for health data components
 */

export const LABS_CATEGORY_NAME = 'Catch Labs';
